import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {L2Model} from '../../../../models/L2Model';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-sl4-filter',
  templateUrl: './sl4-filter.component.html',
  styleUrls: ['./sl4-filter.component.scss']
})
export class Sl4FilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterL2: any[];

  @Input() l2Data: any;
  @Input() l2Selected: L2Model;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('l2Data' in changes) {
      this.listFilterL2 = this.l2Data ? this.l2Data : [];
      this.optionSelected = null;
    }
    if (this.l2Selected) {
      this.optionSelected = this.l2Selected;
    }
  }

  ngOnDestroy(): void {
  }
}
